import { FormFieldsProps } from './index.props';

export const formInitialValues: FormFieldsProps = {
  newPassword: '',
  repeatPassword: '',
};
